import React from "react";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";

interface AuthToggleProps {
  activeTab: "register" | "login";
  setActiveTab: (tab: "register" | "login") => void;
  isLoading?: boolean;
  clearForm: () => void;
}

const AuthToggle: React.FC<AuthToggleProps> = ({
  activeTab,
  setActiveTab,
  isLoading = false,
  clearForm,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "83%",
        mx:"auto",
        display: "flex",
        backgroundColor: "#fff",
        borderRadius: "9999px",
        padding: "2%",
        // boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
        marginBottom: 2,
        overflow: "hidden",
        boxShadow: "0px 10px 10px 0px #F9B4FF33",
      }}
    >
      {/* Sliding Background */}
      <motion.div
        layout
        transition={{ type: "spring", stiffness: 280, damping: 26 }}
        style={{
          position: "absolute",
          top: 6,
          bottom: 6,
          left: activeTab === "register" ? 6 : "calc(50% + 3px)",
          width: "calc(50% - 12px)",
          borderRadius: "9999px",
          background: "linear-gradient(180deg, #9D79F4 0%, #7747FB 100%)",
          boxShadow: "0 4px 12px rgba(119, 71, 251, 0.4)",
        }}
      />

      {/* Register Button */}
      <Button
        disableRipple
        onClick={() => {
          if (isLoading) return;
          setActiveTab("register");
          clearForm();
        }}
        sx={{
          flex: 1,
          borderRadius: "9999px",
          fontWeight: 600,
          fontSize: 14,
          textTransform: "none",
          color: activeTab === "register" ? "#fff" : "#8C8C8C",
          transition: "color 0.3s ease",
          zIndex: 1,
          py: 1.2, // padding inside the button
        }}
      >
        Register
      </Button>

      {/* Login Button */}
      <Button
        disableRipple
        onClick={() => {
          if (isLoading) return;
          setActiveTab("login");
          clearForm();
        }}
        sx={{
          flex: 1,
          borderRadius: "9999px",
          fontWeight: 600,
          fontSize: 14,
          textTransform: "none",
          color: activeTab === "login" ? "#fff" : "#8C8C8C",
          transition: "color 0.3s ease",
          zIndex: 1,
          py: 1.2,
        }}
      >
        Login
      </Button>
    </Box>
  );
};

export default AuthToggle;
